import React from 'react'
import InputComp from './InputComp'
import ButtonAction from './ButtonAction'
import DiabetesActions from '../../Actions/DiabetesActions'

export default class CardName extends React.Component {
  constructor (props) {
      super (props)
      this.state = ({
          _id:props.datos._id,
        control:props.datos.control,
        timestamp:props.datos.timestamp
      })
      this.DiabetesActions =  new DiabetesActions()
  }
  componentWillReceiveProps(props) {
    console.log(props)
      this.setState({
        _id:props.datos._id,
        control:props.datos.control,
        timestamp: props.datos.timestamp
      })
  }
  borrar (id) {
      this.props.onDelete(this.state)
      let url = 'api/v1/diabetes'
      this.DiabetesActions.borrar(this.state,url, () => {

      })

  }
  editar(id){
    let url = 'api/v1/diabetes/especial'
    this.DiabetesActions.actualizar(this.state,url, () => {

    })

  }
  changeInput(e){
      console.log(e.target.name)
      let objState = {}
      objState[e.target.name] = e.target.value
      this.setState(objState)
  }

  render () {
    // console.log(this.props.datos)
    return <div id={this.props.datos._id} key={this.props.index}>
      <div className="contentBox">
        <span> Control: </span>
          <InputComp key={'control'+this.props.keyData} name="control" onChange_={(e) => this.changeInput(e)}  value={this.state.control} onChange/>
        <span>Fecha:</span>
          <InputComp key={'timestamp'+this.props.keyData} name="timestamp" onChange_={(e) => this.changeInput(e)}  value={this.state.timestamp}/>
          <ButtonAction key={'editar'+this.props.keyData} onClick_={() => this.editar(this.props.datos._id)}  actionName="Editar"/>
          <ButtonAction key={'borrar'+this.props.keyData} onClick_={() => this.borrar()} actionName="Borrar"/>
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Patient/SuperDiabetesMix/CardDiabetes.js